import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ShowList from '../../containers/ShowsList/ShowsList';
import { LANDING as landingTitle } from '../../constants/titles';
// import * as actions from '../../store/actions/index';
import { fetchShows } from '../../store/actions';
import { saveMovieReminderSubscription } from '../../store/actions';
import ResponsiveWrapper from '../../components/UI/ResponsiveWrapper/ResponsiveWrapper';
import { Carousel, Col, Image, Row } from 'react-bootstrap';
import Kinostyles from '../../components/Util/AutokinoStylesComponent.module.css';
import * as ROUTES from '../../constants/routes';
import image1 from '../../assets/images/autokino/kinoprogramm/glueckliche_kinobesucher_warten_auf_kinoprogramm.jpg';
import image3 from '../../assets/images/autokino/kinoprogramm/test_cockails_zum_kinoprogramm_wien_im_autokino.jpg';
import image4 from '../../assets/images/autokino/kinoprogramm/test_kino_parkplatz_besucher_kinofilm_start.jpg';
import image2 from '../../assets/images/autokino/kinoprogramm/test_kinosnacks_fuer kinoprogramm_geliefert_zum_auto.jpg';
import FilmprogrammSignup from '../../components/FilmprogrammSignup/FilmprogrammSignup';
import NewsletterSignup from '../../components/NewsletterSignup/NewsletterSignup';
import ScriptTag from 'react-script-tag/lib/ScriptTag';
import { animateScroll as scroll, scroller } from 'react-scroll';
import { useRef } from 'react';
const LandingPage = props => {
  useEffect(() => {
    async function fetchShows() {
      console.log('call fetch categorties');
      await props.fetchShows(null);
    }

    fetchShows();

    const query = new URLSearchParams(window.location.search);
    const opensubscriptionpopup = query.get('openfpsub');
    const selectshow = query.get('selectshow');
    if (opensubscriptionpopup === 'true') {
      setTimeout(function() {
        if (typeof window.mjOpenPopin === 'function') {
          document.getElementById('filmprogrammNewsletterButton').click();
        } else {
          setTimeout(function() {
            document.getElementById('filmprogrammNewsletterButton').click();
          }, 4000);
        }
      }, 2000);
    }
    if (selectshow !== null && selectshow !== '') {
      setTimeout(function() {
        scrollTo(selectshow);
      }, 2000);
    }
  }, []);
  function scrollTo(anchor) {
    scroller.scrollTo(anchor, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
    });
  }
  //console.log('render cat = ' + props.shows.length);

  return (
    <div>
      <Helmet defer={false}>
        <title>{landingTitle}</title>
        <meta
          name="description"
          content="Einzigartiges Kinoerlebnis. Sieger Preis / Leistung Kinotest 2022. Hier geht´s zum Kinoprogramm im Autokino Wien."
        />
        <meta
          name="keywords"
          content="Kinoprogramm Wien, Kino Wien, Kino, Autokino, Bestes Kino, Flohmarkt, Flohmarkt Wien, Eventlocation, Eventlocation Wien, Kinoticket kaufen, Kino Wien Programm, Jetzt im Kino Wien, Kino Samstag, Samstag im Kino, Kinofilme Samstag, Kino in der Nähe, Heute im Kino"
        />

        <link rel="canonical" href="https://autokino.at/kinoprogramm-wien/" />
      </Helmet>
      <ResponsiveWrapper>
        <Row className={Kinostyles.Flex}>
          <Col xs={12} lg={12}>
            <h1 className={Kinostyles.HardelaHeadline}>
              Kinoprogramm – Autokino Wien
            </h1>
            <div className={Kinostyles.TextContainer + ' mt-2'}>
              {' '}
              <ul className={Kinostyles.ulNoMargin}>
                <li>
                  <a
                    href="https://kino-test.at"
                    target="_blank"
                    rel="noreferrer"
                  >
                    🥇 Sieger - Preis / Leistung Kinotest 2022
                  </a>{' '}
                </li>
                <li>
                  <div className="d-none d-md-block ">
                    100% Privatsphäre. Kein stören durch andere Kinogäste
                  </div>
                  <div className="d-block d-md-none ">100% Privatsphäre</div>
                </li>
                <li>
                  <div className="d-none d-md-block ">
                    Du bestimmst die Lautstärke deines Kinofilmes selbst
                  </div>
                  <div className="d-block d-md-none ">
                    Kinofilm Lautstärke selbst wählen
                  </div>
                </li>
                <li>
                  <div className="d-none d-md-block ">
                    Nimm deinen Vierbeiner einfach mit ins Kino
                  </div>
                  <div className="d-block d-md-none ">
                    Nimm deinen Vierbeiner einfach mit
                  </div>
                </li>
                <li>
                  <div className="d-none d-md-block ">
                    Viele weitere Vorzüge warten auf dich im Autokino
                  </div>
                  <div className="d-block d-md-none ">
                    Viele weitere Vorzüge warten auf dich
                  </div>
                </li>
              </ul>
              <br />
              Premium Kino mit einzigartigem Service warten auf DICH!
              <br />
              Genieße die einzigartige Stimmung, großartigen Service und
              wunderbare Sonnenuntergänge mit nachfolgendem Hollywood
              Blockbustern. Freiheit Pur! #HollywoodUnterSternen
              <br />
            </div>
            <Carousel xs={12} lg={12} className={'mt-4 p-2'}>
              <Carousel.Item>
                <h2 className={Kinostyles.TextHeadlineSmallOrange}>
                  Einzigartiges Kinoerlebnis
                </h2>
                <Image
                  src={image1}
                  fluid
                  alt="junges_paerchen_wartet_auf_kinoprogramm_start_wien"
                  title="glueckliche_kinobesucher_warten_auf_kinoprogramm"
                />
              </Carousel.Item>
              <Carousel.Item>
                <h2 className={Kinostyles.TextHeadlineSmallOrange}>
                  Wir liefern
                </h2>
                <Image
                  src={image2}
                  fluid
                  alt="lieferservice_uebergibt_kinosnacks_zu_kinoprogramm"
                  title="kinosnacks_fuer kinoprogramm_geliefert_zum_auto"
                />
              </Carousel.Item>
              <Carousel.Item>
                <h2 className={Kinostyles.TextHeadlineSmallOrange}>
                  Cocktails vom Profi
                </h2>
                <Image
                  src={image3}
                  fluid
                  alt="frische_cocktails_zum_kinoprogramm_wien_autokino"
                  title="cockails_zum_kinoprogramm_im_autokino_wien"
                />
              </Carousel.Item>
              <Carousel.Item>
                <h2 className={Kinostyles.TextHeadlineSmallOrange}>
                  Erlebnis Autokino
                </h2>
                <Image
                  src={image4}
                  fluid
                  alt="kino_parkplatz_besucher_warten_filmstart"
                  title="kino_parkplatz_besucher_kinofilm_start"
                />
              </Carousel.Item>
            </Carousel>
            <br />
            <h2 className={Kinostyles.HardelaHeadlineBig + ' mt-4'}>
              Kinoticket kaufen
            </h2>
          </Col>
        </Row>
      </ResponsiveWrapper>
      <ShowList
        shows={props.shows}
        saveMovieReminderSubscription={props.saveMovieReminderSubscription}
      />
      <ResponsiveWrapper>
        <Row className={Kinostyles.Flex}>
          <Col xs={12} lg={12}>
            <div className={Kinostyles.TextContainer + ' mt-4'}>
              Wir empfehlen:
            </div>
            <h2 className={Kinostyles.HardelaHeadline}>
              Kaufe deine Kinotickets für unser Kinoprogramm online
            </h2>
            <div className={Kinostyles.TextContainer + ' mt-1'}>
              Wir empfehlen Dir deine Kinotickets online rechtzeitig zu kaufen.
              <br />
              Der ein oder andere Film im Kinoprogramm ist immer wieder
              ausverkauft – und du stehst dann bei der Abendkassa aber wir
              können dir für deinen gewählten Film dann keinen Platz mehr zur
              Verfügung stellen.
              <br />
              Außerdem sind die online gekauften Kinotickets im Schnitt um 1nen
              € günstiger wie bei der Abendkassa.
              <br />
              <br />
            </div>
            <h2 className={Kinostyles.HardelaHeadline}>
              Infos zum Kinoprogramm Wien - Autokino
            </h2>
            <div className={Kinostyles.TextContainer + ' mt-1'}>
              Wir erstellen das Kinoprogramm für euch wöchentlich. Am Spielplan
              findet ihr meist aktuelle Hollywood Blockbuster, vereinzelt auch
              in OV und immer wieder auch Filmklassiker.
              <br />
              Du möchtest nicht wöchentlich unser Filmprogramm durchstöbern ob
              für dich der passende Film / Genre dabei ist? Wir erinnern wir
              dich gerne GRATIS.
              <br />
              <br />
            </div>
            <h3 className={Kinostyles.HardelaHeadlineSmall}>
              Folgende Erinnerungsmöglichkeiten haben wir für Dich:
            </h3>
            <div className={Kinostyles.TextContainer + ' mt-1'}>
              Du kannst dir deine Lieblingsfilm, dein Genre oder das
              wöchentliche Filmprogramm unkompliziert und gratis via E-Mail
              zusenden lassen. Alle Erinnerungen kannst du jederzeit und nur mit
              2. Klicks problemlos abmelden.
              <br />
              <br />
            </div>
            <h4 className={Kinostyles.HardelaHeadlineSmall}>
              Lieblingsfilm(e) gratis vormerken
            </h4>
            <div className={Kinostyles.TextContainer + ' mt-1'}>
              Du markierst deinen Lieblingsfilm (du kannst auch mehrere Filme
              auswählen). Gibst deine Emailadresse ein. Klickst auf „Jetzt
              Vormerken“. That´s all. Einfach und unkompliziert.
              <br />
              <br />
              <button className={Kinostyles.CTAButton}>
                <a
                  href={ROUTES.UPCOMING_MOVIES}
                  className={Kinostyles.CTAButtonLink}
                >
                  Lieblingsfilm vormerken
                </a>
              </button>
              <br />
              <br />
              <br />
            </div>
            <h4 className={Kinostyles.HardelaHeadlineSmall}>
              Film Genre vormerken
            </h4>
            <div className={Kinostyles.TextContainer + ' mt-1'}>
              Du kommst gern mit deinen Kids zu Kinderfilmen? Oder Horror unter
              freiem Himmel gibt dir den besonderen Kick? Dann merk dich für
              dein favorisiertes Filmgenre an.
              <br />
              <br />
              <button className={Kinostyles.CTAButton}>
                <a
                  href={ROUTES.UPCOMING_MOVIES_GENRE}
                  className={Kinostyles.CTAButtonLink}
                >
                  Genre vormerken
                </a>
              </button>
              <br />
              <br />
              <br />
            </div>
            <h4 className={Kinostyles.HardelaHeadlineSmall}>
              Film Sprache vormerken
            </h4>
            <div className={Kinostyles.TextContainer + ' mt-1'}>
              In Zukunft gedenken wir eure Lieblingsblockbuster auch öfter in
              diversesten Sprachen zu spielen.
              <br />
              Unter anderem in englisch, polnisch, serbokroatisch und türkisch.
              <br />
              Interesse daran - dann einfach im passenden Newsletter eintragen.
              <br />
              Wir informieren dich wenn wir Filme in deiner favorisierten
              Sprache spielen.
              <br />
              <br />
              <button className={Kinostyles.CTAButton}>
                <a
                  href={ROUTES.UPCOMING_MOVIES_OV}
                  className={Kinostyles.CTAButtonLink}
                >
                  Sprache vormerken
                </a>
              </button>
              <br />
              <br />
              <br />
            </div>

            <h4 className={Kinostyles.HardelaHeadlineSmall}>
              Kinoprogramm abonnieren
            </h4>
            <div className={Kinostyles.TextContainer + ' mt-2'}>
              Hier bekommst du 1x wöchentlich gratis unser Filmprogramm in dein
              Maileingang zugestellt.
              <br />
              <br />
              <FilmprogrammSignup />
              <br />
              <br />
            </div>
            <h4 className={Kinostyles.HardelaHeadlineSmall}>
              Unser Kino Newsletter
            </h4>
            <div className={Kinostyles.TextContainer + ' mt-1'}>
              Hier erhältst du wichtige Informationen zu Autokino Aktionen,
              Rabattcodes und Ermäßigungen. <br />
              Allgemeine Kino News – kein Kinoprogramm. Zum Beispiel wenn wir
              wieder retour sind aus der Winterpause und ähnliches. Keine Angst.
              Wir überfluten dich nicht mit Mails. Auch wir können das absolut
              nicht leiden! Die Interessenten dieses Mailings erhalten maximal
              2-3x pro Jahr verständigt.
              <br />
              <br />
              <NewsletterSignup />
              <br />
              <br />
            </div>
            <h2 className={Kinostyles.HardelaHeadline}>
              Du warst noch NIE im Autokino? NO WORRIES!
            </h2>
            <div className={Kinostyles.TextContainer + ' mt-1'}>
              Hier erfährst du alles was dich vor deinem ersten Autokinobesuch
              wissen möchtest.
              <br />
              <a href={ROUTES.FAQ_AUTOKINO}>So funktioniert Autokino</a>
              <br />
              <br />
            </div>
            <h2 className={Kinostyles.HardelaHeadline}>
              Kino Gutscheine online kaufen
            </h2>
            <div className={Kinostyles.TextContainer + ' mt-1'}>
              Du möchtest besondere Momente schenken? Ideal für eine Vielzahl
              von Anlässen. Jetzt online bestellen.
              <br />
              <br />
              <button className={Kinostyles.CTAButton}>
                <a href={ROUTES.GIFTCARD} className={Kinostyles.CTAButtonLink}>
                  Gutscheine online kaufen
                </a>
              </button>
              <br />
              <br />
            </div>
          </Col>
        </Row>
      </ResponsiveWrapper>
    </div>
  );
};

LandingPage.propTypes = {
  fetchShows: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    shows: state.shows.shows,
  };
};

export default connect(
  mapStateToProps,
  { fetchShows, saveMovieReminderSubscription }
)(LandingPage);
